// src/layouts/corui/BackLayout.jsx
import React from "react"
import { AppContent, AppFooter, AppHeader, AppSidebar } from "./components"
import CoreUIStyles from "../../CoreUIStyles";

const BackCoreLayout = () => {
    return (
        <div>
            <CoreUIStyles /> {/* 👈 Charge les styles CoreUI */}
            <AppSidebar />
            <div className="wrapper d-flex flex-column min-vh-100">
                <AppHeader />
                <div className="body flex-grow-1">
                    <AppContent />
                </div>
                <AppFooter />
            </div>
        </div>
    )
}

export default BackCoreLayout
